import script from "./ConstructivesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructivesList.vue?vue&type=script&setup=true&lang=js"

import "./ConstructivesList.vue?vue&type=style&index=0&id=17b6bfb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b6bfb9"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTr,QTd});
